import { AbstractExplanation } from '../../../../question-data-model/Explanation/abstract-explanation.store';
import { ERROR_NEED_OVERRIDE } from '../../../../question-data-model/constants';

export const AdminExplanationStore = AbstractExplanation.named('AdminExplanationStore')
  .views((self) => ({
    get isCompleted(): boolean {
      throw new Error(`${self.type} ${ERROR_NEED_OVERRIDE}`);
    },
    get isDirty(): boolean {
      throw new Error(`${self.type} ${ERROR_NEED_OVERRIDE}`);
    },
  }))
  .actions((self) => ({
    sync() {
      throw new Error(`${self.type} ${ERROR_NEED_OVERRIDE}`);
    },
    init(data: any) {
      throw new Error(`${self.type} ${ERROR_NEED_OVERRIDE}`);
    },
    getObj() {
      throw new Error(`${self.type} ${ERROR_NEED_OVERRIDE}`);
    },
  }));
